;( function( $, window, document, undefined )
{
    'use strict';

    var $win			= $( window ),
        throttle		= function(a,b){var c,d;return function(){var e=this,f=arguments,g=+new Date;c&&g<c+a?(clearTimeout(d),d=setTimeout(function(){c=g,b.apply(e,f)},a)):(c=g,b.apply(e,f))}},

        throttleTO		= false,
        laziness		= false,
        disqusConfig	= false,
        scriptUrl		= false,

        scriptStatus	= 'unloaded',
        $instance		= $(),

        init = function() {

            if( !$instance.length || $instance.data( 'disqusLoaderStatus' ) === 'loaded' )
                return true;

            var winST = $win.scrollTop();

            // // if the element is too far below || too far above
            // if( $instance.offset().top - winST > $win.height() * laziness || winST - $instance.offset().top - $instance.outerHeight() - ( $win.height() * laziness ) > 0 )
            //     return true;

            $instance.data( 'disqusLoaderStatus', 'loaded' );

            if( scriptStatus === 'loaded') {
                if( typeof window.DISQUS !== "undefined" ) {
                    window.DISQUS.reset({ reload: true, config: disqusConfig });
                }
            } else {

                window.disqus_config = disqusConfig;

                if( scriptStatus === 'unloaded' ) {

                    scriptStatus = 'loaded';

                    var dsq = document.createElement('script');
                        dsq.type = 'text/javascript';
                        dsq.async = true;
                        dsq.src = scriptUrl;

                    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);

                }
            }
        };

    $win.on( 'scroll resize', throttle( throttleTO, init ));

    $.disqusLoader = function( element, options ) {
        options = $.extend({},
            {
                laziness:		1,
                throttle:		250,
                scriptUrl:		false,
                disqusConfig:	false,

            }, options );

        laziness		= options.laziness + 1;
        throttleTO		= options.throttle;
        disqusConfig	= options.disqusConfig;

        scriptUrl		= scriptUrl === false ? options.scriptUrl : scriptUrl; // set it only once
        $instance		= ( typeof element === 'string' ? $( element ) : element ).eq( 0 );

        document = $instance.get(0).ownerDocument;
        window = document.parentWindow || document.defaultView;

        $instance.data( 'disqusLoaderStatus', 'unloaded' );

        init();
    };

})( $b_jQuery, window, document );
